import { Component, OnInit, Input, ViewChild, ElementRef, SimpleChanges } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { ProductService } from 'src/app/services/api/product/product.service';
import { OwlOptions, CarouselComponent } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-slider-prod-gallery',
  templateUrl: './slider-prod-gallery.component.html',
  styleUrls: ['./slider-prod-gallery.component.css']
})
export class SliderProdGalleryComponent implements OnInit {

  @ViewChild('carousel') carousel: CarouselComponent|any;

  @Input() prod: any;
  @Input() width: string|any;

  customOptions: OwlOptions = {
    loop: true,
    autoplay: true,
    items: 1,
    margin: 0,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    nav: false
  }

  gallery: any;

  showArrows: boolean = true;
  loader: boolean = true;

  constructor(
    private media: MediaObserver,
    private prodApi: ProductService
  ) {
    this.manageResp();
  }

  ngOnInit() {
    this.getGallery();
  }

  getGallery() {
    this.prodApi.$_getGallery(this.prod.id).then(data => {
      this.gallery = this.parseGallery(data.list);
      this.loader = false;
    })
  }

  parseGallery(gallery: any) {

    let parsedGallery = [];

    if (gallery.length > 0) {

      gallery.map((prodImg:any) => {

        parsedGallery.push({
          image: prodImg.image[3],
          thumbImage: prodImg.image[3],
          alt: "",
          title: ""
        })

      })

    }
    // Image par défaut
    else {

      parsedGallery.push({
        image: "/assets/img/not-found.png",
        thumbImage: "/assets/img/not-found.png",
        alt: "",
        title: ""
      });
    }

    return parsedGallery;
  }

  prevImageClick() {
    this.carousel.prev();
  }

  nextImageClick() {
    this.carousel.next();
  }

  manageResp() {
    this.media.asObservable().subscribe(media => {
      if (this.media.isActive("xs")) {
        this.showArrows = false;
      }
    })
  }

}
